module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrows-h-0f2a81422998b9ba4b9e0eb93941e02d.svg";